import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-left-sidebar-1-content-scroll',
    templateUrl  : './left-sidebar-1.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedLeftSidebar1ContentScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
